// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageWrapper":"app-components-interestform-slides-delivermore-delivermore--imageWrapper"};